/*Recurso: Files - - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    UploadFilesDecision              //*RP
    UploadFilesAnalysis              //*RD
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const filesStore = create((set:any, get:any) => ({

  objErrorFilesStore: { hasError: false, url: '', body:'', recurso:"files", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error
 
      //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI
      limpiaObjErrorFilesStore: () => {
          let paso = { hasError: false, url:'', body:'', recurso:'files', componente:'', idresul:0, desresul:'', menu:''}
          set( { objErrorFilesStore: paso } );
          //console.log('filesStore - limpiaobjErrorFilesStore (sale) - objErrorFilesStore: ', get().objErrorFilesStore);
      },
        
      //*Error en api // entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
      generaObjErrorFilesStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
          //console.log('****generaobjErrorFilesStore (entra): ', responseAPI);
          //console.log('*generaobjErrorFilesStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
          let paso = { hasError: h, url:'', body:e, recurso:'files', componente:c, idresul:0, desresul:'', menu:m}
          if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
            paso.idresul=-1;
            paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
          }
          else if (responseAPI=='Error detectado por api en ret') {
            paso.desresul= h;
            paso.idresul= h2; 
          }
          else {
            let temp = responseAPI.config;
            paso.url = temp.url;
            if (responseAPI.data!="" && responseAPI.data!=null){
              paso.idresul=responseAPI.data.ret;
              paso.desresul= responseAPI.data.msjerror;
            }    
            else {
                paso.idresul= responseAPI.status;
                if (responseAPI.status==404)
                    paso.desresul= "El usuario no existe"//responseAPI.statusText;  
                else
                    paso.desresul= responseAPI.statusText;  
            }    
          }
          set( { objErrorFilesStore: paso } );
          console.log('filesStore - generaObjError (sale) - objError: ', get().objErrorFilesStore);
      },

   uploadFilesDecisionStore:{}, 
      
      //*Tarea: UploadFilesDecision, envia los archivos a la nas
      guardaUploadFilesDecisionStore: async (responseAPI:any) => {  
        if (responseAPI.ret==1) { //sin error
            set( { uploadFilesDecisionStore: responseAPI } ); 
            //console.log('uploadFilesDecisionStore', get().uploadFilesDecisionStore)
            return(get().uploadFilesDecisionStore);   
        }
        else {
            get().generaObjErrorFilesStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'files.store-guardaDeleteNoticebyUserStore ')
        }
      },

      //*Tarea: UploadFilesAnalysis, envia los archivos a la nas
      guardaUploadFilesAnalysisStore: async (responseAPI:any) => {  
        if (responseAPI.ret==1) { //sin error
            set( { uploadFilesAnalysis: responseAPI } ); 
            //console.log('uploadFilesAnalysis', get().uploadFilesAnalysis)
            return(get().uploadFilesAnalysis);   
        }
        else {
            get().generaObjErrorFilesStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'files.store-guardaUploadFilesAnalysisStore ')
        }
      },
    
}));

export default filesStore;
